import type { GroupedOption } from '@common_components/inputs/selects/selectInput.component';

export const chartTypeOptions: GroupedOption[] = [
  {
    options: [
      { id: 'basic_line', label: 'basic_line' },
      { id: 'area_line', label: 'area_line' },
      { id: 'step_line', label: 'step_line' },
      { id: 'basic_bar', label: 'basic_bar' },
      { id: 'background_bar', label: 'background_bar' },
      { id: 'mixed_line_and_bar', label: 'mixed_line_and_bar' },
      { id: 'progress_gauge', label: 'progress_gauge' },
      { id: 'custom_gauge', label: 'custom_gauge' },
      { id: 'auto_increment_gauge', label: 'auto_increment_gauge' },
    ],
  },
];

export const targetTypeOptions: GroupedOption[] = [
  {
    options: [
      { id: 'min', label: 'min' },
      { id: 'max', label: 'max' },
    ],
  },
];

export const readStartOptions: GroupedOption[] = [
  {
    options: [
      { id: 'd-1', label: 'read_start_d_1' },
      { id: 'w-1', label: 'read_start_w_1' },
      { id: 'm-1', label: 'read_start_m_1' },
      { id: 'y-1', label: 'read_start_y_1' },
      { id: 'd', label: 'read_start_d' },
      { id: 'w', label: 'read_start_w' },
      { id: 'm', label: 'read_start_m' },
      { id: 'y', label: 'read_start_y' },
    ],
  },
];

export const readEndOptions: GroupedOption[] = [
  {
    options: [
      { id: 'd-15', label: 'read_end_d_15' },
      { id: 'd-30', label: 'read_end_d_30' },
      { id: 'w-5', label: 'read_end_w_5' },
      { id: 'w-10', label: 'read_end_w_10' },
      { id: 'm-3', label: 'read_end_m_3' },
      { id: 'm-6', label: 'read_end_m_6' },
      { id: 'm-12', label: 'read_end_m_12' },
      { id: 'y-5', label: 'read_end_y_5' },
    ],
  },
];

export const historyOptions: GroupedOption[] = [
  {
    options: [
      { id: 'none', label: 'none' },
      { id: 'moyenne', label: 'moyenne' },
      { id: 'median', label: 'median' },
      { id: 'cumul', label: 'cumul' },
      { id: 'trend', label: 'chart_indicator_trend' },
    ],
  },
];
